// Damped third-person follow camera: trails behind the plane, looks ahead.

import * as THREE from 'three';
import type { Plane } from '../plane/Plane';

const TRAIL = new THREE.Vector3(0, 2.0, -7.0); // local offset behind plane
const LOOKAHEAD = new THREE.Vector3(0, 0, 12); // local offset ahead of plane

export class FollowCamera {
  camera: THREE.PerspectiveCamera;
  private currentPos = new THREE.Vector3();
  private currentLook = new THREE.Vector3();

  constructor(aspect: number) {
    this.camera = new THREE.PerspectiveCamera(72, aspect, 0.1, 2000);
    this.camera.position.set(0, 4, -12);
  }

  resize(aspect: number): void {
    this.camera.aspect = aspect;
    this.camera.updateProjectionMatrix();
  }

  follow(target: Plane, dt: number, snap = false): void {
    const m = new THREE.Matrix4().makeBasis(target.right, target.up, target.forward);
    const desiredPos = target.position.clone().add(TRAIL.clone().applyMatrix4(m));
    const desiredLook = target.position.clone().add(LOOKAHEAD.clone().applyMatrix4(m));

    if (snap) {
      this.currentPos.copy(desiredPos);
      this.currentLook.copy(desiredLook);
    } else {
      const k = 1 - Math.exp(-dt * 5);
      this.currentPos.lerp(desiredPos, k);
      this.currentLook.lerp(desiredLook, k);
    }
    this.camera.position.copy(this.currentPos);
    this.camera.up.copy(target.up);
    this.camera.lookAt(this.currentLook);
  }
}
